import React from 'react';
import { has, get } from "lodash"

import { sexData } from "../sex/static.sexData"
import { resultData } from "../result/static.resultData"
import LinkFill from "../../../shared/items/controls/linkFill"
import locales from "./../../../content.json"

import styles from "./imageResultBlockWithTransform.module.scss"

import female2 from "./img/female2.jpg"
import male2 from "./img/male2.jpg"

const ImageResultBlock = (props) => {
  const { data } = props;

  return (
    <div className={styles.imageResultBlock}>
      {
        get(data, ["sex", "value"]) === sexData.male.value
          ? <img className={styles.maleImage} src={male2} alt="" />
          : null
      }

      {
        get(data, ["sex", "value"]) === sexData.female.value
          ? <img className={styles.femaleImage} src={female2} alt="" />
          : null
      }

      <div className={styles.container_titleSex}>
        <span className={styles.title}>
          {
            get(data, ["sex", "value"]) === sexData.male.value
              ? get(data, ["result", "value"]) === resultData.male.lose.value
                ? locales[window.userLang].loss_plan
                : get(data, ["result", "value"]) === resultData.male.muscle.value
                  ? locales[window.userLang].gain_plan
                  : locales[window.userLang].fitness_plan
              : get(data, ["sex", "value"]) === sexData.female.value
                ? get(data, ["result", "value"]) === resultData.female.lose.value
                  ? locales[window.userLang].loss_plan
                  : get(data, ["result", "value"]) === resultData.female.tone.value
                    ? locales[window.userLang].fitness_plan
                    : get(data, ["result", "value"]) === resultData.female.love.value
                      ? locales[window.userLang].fitness_plan
                      : locales[window.userLang].fitness_plan
                : get(data, ["sex", "value"]) === sexData.other.value
                  ? locales[window.userLang].loss_plan
                  : get(data, ["result", "value"]) === resultData.other.tone.value
                    ? locales[window.userLang].fitness_plan
                    : get(data, ["result", "value"]) === resultData.other.love.value
                      ? locales[window.userLang].fitness_plan
                      : locales[window.userLang].fitness_plan
          }
        </span>
      </div>

    </div>
  )
}

export default ImageResultBlock;